<ng-template #clientSelectModal let-modal>
    <div class="modal-header" style="padding: 10px;">
        <h6 class="modal-title" id="modal-basic-title" style="margin-top: 0px;">Select Client</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="font-size: 12px;">
        <section class="company-list-container">
            <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters" [pageSize]="20"
                [filtersComponent]="dataFilters" (onTableRowClick)="onTableRowClickEvent($event)">
                <app-data-filters #dataFilters>
                    <app-data-filter-group>
                        <app-data-filter-input label="Customer name" [(model)]="filters.customerName"
                            placeholder="Customer Name"></app-data-filter-input>
                        <app-data-filter-input [label]="'client-list.company.label' | translate"
                            [(model)]="filters.company" [placeholder]="'client-list.company.placeholder' | translate">
                        </app-data-filter-input>
                    </app-data-filter-group>
                </app-data-filters>
            </app-data-table>
        </section>
    </div>
    <div class="modal-footer">
        <button class="btn btn-sm btn-primary" (click)="modal.dismiss('close')">Close</button>
    </div>
</ng-template>

<!-- <button class="btn btn-sm btn-primary" style="margin:0px;" (click)="open(priceListPreview)" [disabled]="disabled">Details</button> -->
<div class="form-group">
    <label class="control-label" *ngIf="showLabel">{{labelText}}</label>
    <div class="input-group input-group-sm">
        <input type="text" class="form-control" placeholder="Search Company" disabled="disabled"
            [(ngModel)]="clientName">
        <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="button" (click)="openModal(clientSelectModal)"><i
                    class="fa fa-search"></i></button>
        </div>
    </div>
</div>

<ng-template #customerName let-firstName="firstName" let-lastName="lastName">
    {{firstName}} {{lastName}}
</ng-template>

<ng-template #clientStatusColumn let-status="status">
    {{status | clientStatus}}
</ng-template>

<ng-template #companyColumn let-company="company">
    <span *ngIf="company"> {{company.name}} </span>
</ng-template>

<ng-template #actionsColumn let-id="id">
    {{id}}
</ng-template>